
















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class RcaBuilder extends Vue {
  @Prop({ default: null }) eventId!: number | null;
  @Prop({ default: () => [] }) rcaItems!: any[];

  localItems: any[] = [];

  mounted() {
    this.localItems = this.rcaItems.length > 0
      ? [...this.rcaItems]
      : [this.emptyItem()];
  }

  @Watch("localItems", { deep: true })
  onItemsChange() {
    this.$emit("update", this.localItems);
  }

  emptyItem() {
    return {
      masalah_gap: "",
      analisa_akar_masalah: "",
      rencana_tindak_lanjut: "",
      rtl_penanggung_jawab_id: null,
      rtl_penanggung_jawab_nama: "",
      rtl_deadline: "",
      rtl_status: "open",
    };
  }

  addItem() {
    this.localItems.push(this.emptyItem());
  }

  removeItem(idx: number) {
    if (this.localItems.length <= 1) return;
    this.localItems.splice(idx, 1);
  }

  statusColor(status: string) {
    const map: any = { open: "grey", in_progress: "blue", closed: "green", overdue: "red" };
    return map[status] || "grey";
  }
}
